import { render, staticRenderFns } from "./PublicatorDialog.vue?vue&type=template&id=583c1f2a&scoped=true"
import script from "./PublicatorDialog.vue?vue&type=script&lang=js"
export * from "./PublicatorDialog.vue?vue&type=script&lang=js"
import style0 from "./PublicatorDialog.vue?vue&type=style&index=0&id=583c1f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c1f2a",
  null
  
)

export default component.exports